<!--
  AlertMessage.svelte — Dismissible alert banner for success/error/info/warning.

  Wraps flowbite-svelte's Alert with a consistent icon mapping and
  optional auto-dismiss timer.

  @prop {'success'|'error'|'info'|'warning'} type — Alert severity.
  @prop {string} message — Text to display.
  @prop {boolean} [dismissible] — Show close button. Default: true.
-->
<script lang="ts">
	import { Alert } from 'flowbite-svelte';

	
	
	
	interface Props {
		/** Alert severity level. Controls color and icon. */
		type?: 'success' | 'error' | 'info' | 'warning';
		/** The message text to display inside the alert. */
		message: string;
		/** Whether the alert can be dismissed by the user. */
		dismissible?: boolean;
		/** Callback fired when the alert is dismissed. */
		onclose?: () => void;
	}

	let { type = 'info', message, dismissible = true, onclose }: Props = $props();

	/** Map severity to flowbite color prop. */
	const colorMap: Record<string, 'green' | 'red' | 'blue' | 'yellow'> = {
		success: 'green',
		error: 'red',
		info: 'blue',
		warning: 'yellow'
	};

	/** Map severity to Font Awesome icon class. */
	const iconMap: Record<string, string> = {
		success: 'fa-circle-check',
		error: 'fa-circle-xmark',
		info: 'fa-circle-info',
		warning: 'fa-circle-exclamation'
	};

	/** Whether the alert is currently visible. */
	let visible = $state(true);
</script>

{#if visible && message}
	<Alert color={colorMap[type]} dismissable={dismissible} class="mb-4" bind:alertStatus={visible} onclick={() => onclose?.()}>
		{#snippet icon()}

				<i class="fa-solid {iconMap[type]} h-5 w-5"></i>

			{/snippet}
		{message}
	</Alert>
{/if}
